export default __webpack_public_path__ + "alberta-enteral-nutrition.3d13099443dcf332f6c8.svg";